import React, { useEffect } from "react";
import ReactGA from "react-ga";
import { useContent } from "../contexts/contentContext/contentContext.js";
import { useUser } from "../contexts/userContext/userContext.js";
const GoogleAnalyticsHandler = () => {
  const {
    isBasicSettingsInitialized,
    setIsGoogleAnalyticsInitialized,
    getBasicSettingsData,
  } = useContent();

  const { getUserData } = useUser();

  useEffect(() => {
    //don't use google analytic in pre-rendered static pages */}
    if (navigator.userAgent !== "ReactSnap") {
      //basic settings initialized
      if (isBasicSettingsInitialized()) {
        ReactGA.initialize(getBasicSettingsData().googleAnalyticsAccount);
        setIsGoogleAnalyticsInitialized(true);
      }
    }
  }, [isBasicSettingsInitialized()]);

  useEffect(() => {
    if (getUserData()) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        user_id: getUserData().UserId,
        user_subscribe: getUserData().IsSubscribed,
        user_subscription_type: getUserData().Subscription,
      });
    }
  }, [getUserData()]);

  return <></>;
};

export const addGoogleAnalyticsEvent = ({ category, action, value, label }) => {
  ReactGA.event({
    category: category,
    action: action,
    value: value,
    label: label,
  });
};

export const AddGoogleAnalyticsPageView = ({
  isGoogleAnalyticsInitialized,
}) => {
  if (isGoogleAnalyticsInitialized()) {
    const path = window.location.pathname;
    ReactGA.set({ path });
    ReactGA.pageview(path);
  }
};

export default GoogleAnalyticsHandler;
